<script setup lang="ts">
import { RTEControlEmbedLink } from '@gohighlevel/ghl-text-editor'
import { inject, ref, watch } from 'vue'
import { Editor } from '@tiptap/vue-3'
import { usePropertiesDrawer } from '@/composable/usePropertiesDrawer'

const props = defineProps<{
  editor: Editor
  language: string
}>()

const linkState = ref()
const { setClose } = usePropertiesDrawer()

// Inject the link state provided by RichTextEditor
const injectedLinkState = inject('rte-link-state', null)

// Watch for changes in the injected link state
watch(
  () => injectedLinkState,
  newState => {
    if (newState) {
      linkState.value = newState
    }
  },
  { immediate: true }
)

// Handle click event to prevent propagation
const handleClick = (event: MouseEvent) => {
  event.stopPropagation()
  event.preventDefault()
  // Close the properties tab when link button is clicked
  setClose()
}
</script>

<template>
  <div @click="handleClick">
    <RTEControlEmbedLink
      :editor="props.editor"
      :language="props.language"
      :initial-values="linkState"
    />
  </div>
</template>
